import { StoresSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetStoresParams = Static<typeof GetStoresParamsSchema>;
export const GetStoresParamsSchema = Type.Object(
  {
    retailUnit: Type.String({ minLength: 2, maxLength: 2 }),
    language: Type.String({ minLength: 2, maxLength: 2 }),
  },
  { additionalProperties: false, $id: 'GetStoresParamsSchema' }
);

export type GetStoresResponse = Static<typeof GetStoresResponseSchema>;
export const GetStoresResponseSchema = Type.Object(
  {
    stores: StoresSchema,
  },
  { additionalProperties: false, $id: 'GetStoresResponseSchema' }
);
